import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Filter = ({ isVisible, onFilter, onClose, onResetFilter, children }) => {
    const { t } = useTranslation("common");
    
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                e.preventDefault(); 
                onFilter(); 
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onFilter]);
    return (
        <div className={`main-list__filters ${isVisible ? "main-list__filters--active" : ""}`}>
            <div className="main-list__filters-wrap">
                <div className="main-list__filters-left-sidebar">
                    <button onClick={onResetFilter}>
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                    <button onClick={onFilter}>
                        <i className="fa-solid fa-bars-filter"></i>
                    </button>
                </div>
                <div className="right-col__filters">
                    <div className="main-list__filters-header">
                        <div className="main-list__filters-title">
                            <span>{t('filters')}</span>
                        </div>
                        <button className="main-list__filters-close-btn" onClick={onClose}>
                            <i className="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                    <div className="main-list__filters-body">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Filter;
